import { useCustomEventListener } from '../../hooks/use_custom_event_listener';
import { useEffect, useState } from 'react';
import { Nullable } from '../../utilities/common_types';
import { useAppState } from '../../contexts/app_state/use_app_state_context';
import { AppState } from '../../contexts/app_state/app_state_context';

export const DEEP_LINK_POST_EVENT_KEY = 'deepLinkPost';

export interface DeepLinkPostEventDetails {
  uri: string;
}

export const useDeepLinkPost = () => {
  const [deepLinkUri, setDeepLinkUri] = useState<Nullable<string>>(null);
  const { status } = useAppState();

  useCustomEventListener(DEEP_LINK_POST_EVENT_KEY, (event) => {
    if (!event.detail.uri || event.detail.uri === 'null') {
      return;
    }

    let formattedUri = event.detail.uri;
    if (!formattedUri.startsWith('/')) {
      formattedUri = `/${formattedUri}`;
    }

    setDeepLinkUri(formattedUri);
  });

  useEffect(() => {
    if (status === AppState.inactive) {
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect
      setDeepLinkUri(null);
    }
  }, [status]);

  return { deepLinkUri };
};
